import { BaseHTMLElement } from "../BaseHTMLElement";

export class Button extends BaseHTMLElement {
    constructor(className?: string) {
        super('button', className);
    }

    public setText(text: string): this {
        this.element.textContent = text;
        return this;
    }

    public setPrimary(): this {
        this.element.classList.add('btn-primary');
        return this;
    }

    public setSecondary(): this {
        this.element.classList.add('btn-secondary');
        return this;
    }

    public onClick(handler: () => void): this {
        this.addEventListener('click', handler);
        return this;
    }
}